import { logEvent } from "firebase/analytics"; // Import logEvent from firebase/analytics
import { analytics } from "../firebase"; // Import the analytics instance

/**
 * Asynchronous function to track order placement events with Firebase Analytics.
 * It retrieves UTM parameters from sessionStorage and logs them as custom event parameters.
 * After logging, it clears the UTM parameters from sessionStorage.
 * @param {string} orderId - The ID of the newly created order.
 */
const trackOrderPlacement = async (orderId) => {
  try {
    // Retrieve UTM parameters from sessionStorage
    const utmSource = sessionStorage.getItem("utm_source") || "direct";
    const utmMedium = sessionStorage.getItem("utm_medium") || "none";
    const utmCampaign = sessionStorage.getItem("utm_campaign") || "none";

    // Log a custom order_placed event to Firebase Analytics with UTM parameters
    logEvent(analytics, "order_placed", {
      order_id: orderId,
      source: utmSource,
      medium: utmMedium,
      campaign: utmCampaign,
    });

    console.log("Order placement event logged to Firebase Analytics:", {
      orderId,
      utmSource,
      utmMedium,
      utmCampaign,
    });

    // Clear UTM parameters from sessionStorage after successful order creation tracking
    // sessionStorage.removeItem("utm_source");
    // sessionStorage.removeItem("utm_medium");
    // sessionStorage.removeItem("utm_campaign");
  } catch (error) {
    console.error("Failed to track order placement event:", error);
  }
};

export default trackOrderPlacement;
